import { PageCursor } from "./PageCursor";
import { Runtype, Array, Record } from "runtypes";

export const Page = <T extends Runtype>(runtype: T) => {
  return Record({
    items: Array(runtype),
    cursor: PageCursor,
  });
};
